
export const googleSiteKey = '6LeNe6sUAAAAABBsXVPiM5QYd0FMHZKHq-Oh3raa';
export const googleSignInKey = '435313069030-5m2tpfkngnoavuodpu8k2ok7bekl4m6d.apps.googleusercontent.com';

export function post(path, params, method='post') {

    // The rest of this code assumes you are not using a library.
    // It can be made less wordy if you use one.
    const form = document.createElement('form');
    form.method = method;
    form.action = path;

    for (const key in params) {
        if (params.hasOwnProperty(key)) {
            const hiddenField = document.createElement('input');
            hiddenField.type = 'hidden';
            if (key === 'g_recaptcha_response') {
                hiddenField.name = 'g-recaptcha-response';
            } else {
                hiddenField.name = key;
            }
            hiddenField.value = params[key];

            form.appendChild(hiddenField);
        }
    }

    document.body.appendChild(form);
    form.submit();
}

export function get_messages(form_name, setStr ) {

    let xhr = new XMLHttpRequest();
    xhr.open("POST", '../services/get_messages.php', true);
    xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

    xhr.onreadystatechange = function() {//Вызывает функцию при смене состояния.
        if(xhr.readyState == XMLHttpRequest.DONE && xhr.status == 200) {

            //console.log( xhr.response );
            //console.log(typeof setStr);
            let response = xhr.response.replace(/<br>/g, '\n');
            setStr( response );
        }
    }
    xhr.send('form_name='.concat(form_name));

}



export default post;
